/**
 * This file contains utilities for shape transformations
 * */
import { logInDev } from './log-utils';

const interpolateString = (template, data) => {
  const braceRegex = /{(.*?)}/g;
  return template && template.replace(braceRegex, (_, key) => {
    let result = data;
    key.split('.').forEach((property) => {
      result = result ? result[property] : '';
    });
    return String(result);
  });
};

const createURLProxy = (urls) => {
  const proxyHandler = {
    get(obj, key) {
      if (key in obj) {
        const interpolate = (data) => interpolateString(obj[key], data);
        interpolate.toString = () => obj[key];
        return interpolate;
      }
      return key;
    },
  };
  return new Proxy(urls, proxyHandler);
};

const isObjectEqualShallow = (a, b) => {
  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;

  for (let i = 0; i < keys.length; i += 1) {
    if (a[keys[i]] !== b[keys[i]]) return false;
  }
  return true;
};

/** obj should always be serializable */
const cloneDeep = (obj) => {
  let clone;
  try {
    clone = JSON.parse(JSON.stringify(obj));
  } catch (e) {
    logInDev(e);
  }
  return clone;
};

const getAtobParsedData = (data) => {
  try {
    return JSON.parse(atob(data));
  } catch (e) {
    logInDev(e);
    return {};
  }
};

const getArrayFromNToM = (n, m) => {
  let res = [];
  for (let i = n; i <= m; i += 1) {
    res = [...res, i];
  }

  return res;
};

const formatDate = (date) => date && new Date(date).toLocaleDateString();

const formatDateTime = (date) => date && new Date(date).toLocaleString();

export {
  interpolateString,
  createURLProxy,
  isObjectEqualShallow,
  cloneDeep,
  getArrayFromNToM,
  formatDate,
  formatDateTime,
  getAtobParsedData,
};
